import { render, staticRenderFns } from "./EditAuthName.vue?vue&type=template&id=0d8b1031&scoped=true"
import script from "./EditAuthName.vue?vue&type=script&lang=js"
export * from "./EditAuthName.vue?vue&type=script&lang=js"
import style0 from "./EditAuthName.vue?vue&type=style&index=0&id=0d8b1031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b1031",
  null
  
)

export default component.exports